import { useState } from 'react';

/**
 * A hook to manage themed confirmation dialogs.
 */
export const useConfirmDialog = () => {
    const [confirmConfig, setConfirmConfig] = useState({
        isOpen: false,
        title: '',
        message: '',
        type: 'warning',
        confirmText: 'Onayla',
        cancelText: 'Vazgeç',
        onConfirm: () => { }
    });

    const showConfirm = (config) => {
        setConfirmConfig({
            isOpen: true,
            title: config.title || 'Onay Gerekiyor',
            message: config.message || 'Bu işlemi yapmak istediğinize emin misiniz?',
            type: config.type || 'warning',
            confirmText: config.confirmText || 'Evet, Onayla',
            cancelText: config.cancelText || 'İptal',
            onConfirm: () => {
                if (typeof config.onConfirm === 'function') {
                    config.onConfirm();
                }
                setConfirmConfig(prev => ({ ...prev, isOpen: false }));
            }
        });
    };

    const closeConfirm = () => {
        setConfirmConfig(prev => ({ ...prev, isOpen: false }));
    };

    return { confirmConfig, showConfirm, closeConfirm };
};
